import Page from '../Page';
import React from 'react';

const AccountPage: React.FC = () => {
	return (
		<Page>
			<p>Account</p>
		</Page>
	);
};

export default AccountPage;
